import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Grid, Menu, Segment } from 'semantic-ui-react';
import React from 'react';
import { setLinkingMenuItem } from 'state/business/actions';
import GoBizLinking from './GoBizLinking';
import styles from './BusinessDetailSections.module.css';

const LinkingSection = props => {
  const { linkingMenuItem, dispatch } = props;

  const handleLinkingTabItemClick = (e, { name }) => {
    dispatch(setLinkingMenuItem(name));
  };

  return (
    <div className={styles.section}>
      <Grid>
        <Grid.Column stretched width={3}>
          <Menu fluid vertical tabular>
            <Menu.Item
              name="Gobiz"
              active={linkingMenuItem === 'Gobiz'}
              onClick={handleLinkingTabItemClick}
            />
          </Menu>
        </Grid.Column>
        <Grid.Column stretched width={13}>
          <div className={styles['item-component']}>
            <Segment>
              {linkingMenuItem === 'Gobiz' ? <GoBizLinking /> : <></>}
            </Segment>
          </div>
        </Grid.Column>
      </Grid>
    </div>
  );
};

const mapStateToProps = ({ business }) => ({
  linkingMenuItem: business.linkingMenuItem,
});

LinkingSection.propTypes = {
  dispatch: PropTypes.func.isRequired,
  linkingMenuItem: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(LinkingSection);
